import React from "react";
import { Typography } from "@mui/material/";
import makeStyles from '@mui/styles/makeStyles';
import { styles } from "../../../styles";
import clsx from "clsx";

const PageTitle = React.memo((props) => {
  const classes = makeStyles(styles)();
  const { title } = props;
  if (!title) {
    return null;
  }
  return (
    <Typography variant="h6" className={clsx(classes.mvTitle, classes.paddingLeft16, classes.paddingBottom8)}>
      {title}
    </Typography>
  );
});
export default PageTitle;
